import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SURVEY_FORM_ID } from '../../constants/survey.constants';

interface SurveyFormActionsProps {
  submitLabel: string;
  pendingLabel: string;
  isPending: boolean;
  onCancel: () => void;
}

export function SurveyFormActions({
  submitLabel,
  pendingLabel,
  isPending,
  onCancel,
}: SurveyFormActionsProps) {
  return (
    <>
      <Button type="button" variant="outline" onClick={onCancel} disabled={isPending}>
        Cancel
      </Button>
      <Button type="submit" form={SURVEY_FORM_ID} disabled={isPending} className="gap-1.5">
        {isPending ? <Loader2 className="size-4 animate-spin" aria-hidden /> : null}
        {isPending ? pendingLabel : submitLabel}
      </Button>
    </>
  );
}
